import { BREAKPOINT_MOBILE } from "constants/constants";

import styled from "styled-components/macro";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import {
  MACHINE_BREAKDOWN_METRIC_WIDTH,
  MACHINE_BREAKDOWN_PROCESS_NAME_LINK_WIDTH,
} from "../machineBreakdownChartUtils";
import { useVisibleMetrics } from "components/Dashboard/GroupMetrics/useVisibleMetrics";

// tslint:disable-next-line: cognitive-complexity
export function MachineBreakdownTitleRow({
  showMetrics,
  showMetricsViewInsteadOfTagBreakdown,
}: {
  showMetrics: boolean;
  showMetricsViewInsteadOfTagBreakdown: boolean;
}) {
  const visibleMetrics = useVisibleMetrics();
  const { translate } = useFlightTranslation();
  const metricsTitlesNodes = showMetrics
    ? visibleMetrics.TimelineColumn.map(({ displayName, displayNameShort }) => {
        return (
          <div key={displayName} className="title">
            {(displayNameShort && translate(displayNameShort)) ??
              (displayName && translate(displayName))}
          </div>
        );
      })
    : [];

  return (
    <TitleRowStyles>
      <div className="title machineTitle">{translate("Process")}</div>
      <div className="spacer" />
      {metricsTitlesNodes}
      {metricsTitlesNodes.length > 0 ? <div className="spacer" /> : null}
      {showMetricsViewInsteadOfTagBreakdown ? null : (
        <div className="title tagBreakdownTitle">
          {translate("Tag_Breakdown")}
        </div>
      )}
    </TitleRowStyles>
  );
}

const TitleRowStyles = styled.div`
  display: flex;
  padding: 16px 4px 0 4px;
  @media (min-width: ${BREAKPOINT_MOBILE}px) {
    padding: 16px 24px 0 24px;
  }
  font-weight: bold;
  font-family: "Roboto";
  .title {
    width: ${MACHINE_BREAKDOWN_METRIC_WIDTH}px;
    text-align: right;
    &.machineTitle {
      text-align: left;
      width: ${MACHINE_BREAKDOWN_PROCESS_NAME_LINK_WIDTH}px;
    }
    &.tagBreakdownTitle {
      width: unset;
      flex-grow: 1;
      text-align: left;
    }
  }
`;
